var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGapAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 27.5H22.5C23.163 27.5 23.7989 27.2366 24.2678 26.7678C24.7366 26.2989 25 25.663 25 25V9.375L18.125 2.5H7.5C6.83696 2.5 6.20107 2.76339 5.73223 3.23223C5.26339 3.70107 5 4.33696 5 5V8.75",
    stroke: "#005EB8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.5V10H25",
    stroke: "#005EB8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 21.25C6.74246 21.25 7.23009 21.153 7.68506 20.9645C8.14003 20.7761 8.55343 20.4999 8.90165 20.1517C9.24987 19.8034 9.52609 19.39 9.71455 18.9351C9.903 18.4801 10 17.9925 10 17.5C10 17.0075 9.903 16.5199 9.71455 16.0649C9.52609 15.61 9.24987 15.1966 8.90165 14.8483C8.55343 14.5001 8.14003 14.2239 7.68506 14.0355C7.23009 13.847 6.74246 13.75 6.25 13.75C5.25544 13.75 4.30161 14.1451 3.59835 14.8483C2.89509 15.5516 2.5 16.5054 2.5 17.5C2.5 18.4946 2.89509 19.4484 3.59835 20.1517C4.30161 20.8549 5.25544 21.25 6.25 21.25Z",
    stroke: "#005EB8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22.5L9.375 20.625",
    stroke: "#005EB8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGapAnalysis);
export default __webpack_public_path__ + "static/media/GapAnalysis.fa95a74cfbc2210a010befb001edd9fb.svg";
export { ForwardRef as ReactComponent };